const stateChangeError = $state => {
	$state.defaultErrorHandler(error => {
		// eslint-disable-next-line angular/log
		console.error('State transition error:', error);
	});
};
stateChangeError.$inject = ['$state'];
export default stateChangeError;
